/**
 * /dashboard/maternity-cases — list of maternity cases (G14).
 *
 * HR-admin only — gated both at the role gate here and at the backend
 * (the backend's list endpoint is technically self-OR-HR, but the SPA
 * surfaces this module to HR only because pregnancy status is
 * statutory-protected PII under DPDP Act §11(1)(d)).
 *
 * Statutory anchors surfaced on the page:
 *   - Maternity Benefit Act 1961 §5  (eligibility / 26-week baseline)
 *   - §11A                           (creche facility cross-check on the
 *                                    tenant; surfaced in the page intro)
 *
 * Replaces the v0 <ComingSoon> stub.
 */

import { createFileRoute, Link , useParams} from "@tanstack/react-router";
import { Plus } from "lucide-react";
import { PageHeader } from "@/components/shared/page-header";
import { MaternityRoleGate } from "@/components/maternity/maternity-role-gate";
import { CaseList } from "@/components/maternity/case-list";
import { Button } from "@/components/ui/button";

export const Route = createFileRoute("/_authgated/app/$tenantSlug/maternity-cases/")({
  component: MaternityCasesIndexRoute,
});

function MaternityCasesIndexRoute() {
  const { tenantSlug } = useParams({ strict: false }) as { tenantSlug: string };
  return (
    <MaternityRoleGate>
      <PageHeader
        title="Maternity"
        description="Track every maternity event end-to-end: §5 26-week leave, §9 illness extensions, §10 nursing breaks, and §12 discharge protection."
        actions={
          <Button asChild className="gap-1.5">
            <Link to="/app/$tenantSlug/maternity-cases/new" params={{ tenantSlug }}>
              <Plus className="h-4 w-4" />
              New Maternity Case
            </Link>
          </Button>
        }
      />
      <CaseList />
    </MaternityRoleGate>
  );
}
